import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from 'react';
import TouchableOpacity from "react-native-web/dist/exports/TouchableOpacity";
import Text from "react-native-web/dist/exports/Text";
import PropTypes from 'prop-types';
import styleConstructor from "./style";
import { shouldUpdate } from "../../../component-updater";
import { jsx as ___EmotionJSX } from "@emotion/core";

var Day = function (_Component) {
  _inherits(Day, _Component);

  var _super = _createSuper(Day);

  function Day(props) {
    var _this;

    _classCallCheck(this, Day);

    _this = _super.call(this, props);
    _this.style = styleConstructor(props.theme);
    _this.onDayPress = _this.onDayPress.bind(_assertThisInitialized(_this));
    _this.onDayLongPress = _this.onDayLongPress.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Day, [{
    key: "onDayPress",
    value: function onDayPress() {
      this.props.onPress(this.props.date);
    }
  }, {
    key: "onDayLongPress",
    value: function onDayLongPress() {
      this.props.onLongPress(this.props.date);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return shouldUpdate(this.props, nextProps, ['state', 'children', 'marking', 'onPress', 'onLongPress']);
    }
  }, {
    key: "render",
    value: function render() {
      var containerStyle = [this.style.base];
      var textStyle = [this.style.text];
      var marking = this.props.marking || {};

      if (marking && marking.constructor === Array && marking.length) {
        marking = {
          marking: true
        };
      }

      var isDisabled = typeof marking.disabled !== 'undefined' ? marking.disabled : this.props.state === 'disabled';

      if (marking.selected) {
        containerStyle.push(this.style.selected);
        textStyle.push(this.style.selectedText);
      } else if (isDisabled) {
        textStyle.push(this.style.disabledText);
      } else if (this.props.state === 'today') {
        containerStyle.push(this.style.today);
        textStyle.push(this.style.todayText);
      }

      if (marking.customStyles && typeof marking.customStyles === 'object') {
        var styles = marking.customStyles;

        if (styles.container) {
          if (styles.container.borderRadius === undefined) {
            styles.container.borderRadius = 16;
          }

          containerStyle.push(styles.container);
        }

        if (styles.text) {
          textStyle.push(styles.text);
        }
      }

      return ___EmotionJSX(TouchableOpacity, {
        testID: this.props.testID,
        style: containerStyle,
        onPress: this.onDayPress,
        onLongPress: this.onDayLongPress,
        activeOpacity: marking.activeOpacity,
        disabled: marking.disableTouchEvent,
        accessibilityRole: isDisabled ? undefined : 'button',
        accessibilityLabel: this.props.accessibilityLabel
      }, ___EmotionJSX(Text, {
        allowFontScaling: false,
        style: textStyle
      }, String(this.props.children)));
    }
  }]);

  return Day;
}(Component);

_defineProperty(Day, "displayName", 'IGNORE');

_defineProperty(Day, "propTypes", {
  state: PropTypes.oneOf(['selected', 'disabled', 'today', '']),
  theme: PropTypes.object,
  marking: PropTypes.any,
  onPress: PropTypes.func,
  onLongPress: PropTypes.func,
  date: PropTypes.object
});

export default Day;

if (typeof Day !== 'undefined' && Day && Day === Object(Day) && Object.isExtensible(Day) && !Day.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Day, '__filemeta', {
    configurable: true,
    value: {
      name: "Day",
      filename: "node_modules/react-native-calendars/src/calendar/day/custom/index.js"
    }
  });
}